import { inject } from '@angular/core';
import {
  CombinedGraphQLErrors,
  CombinedProtocolErrors,
  LocalStateError,
  ServerError,
  ServerParseError,
  UnconventionalError
} from '@apollo/client/errors';
import { ErrorLink } from '@apollo/client/link/error';
import * as Sentry from '@sentry/angular';
import { Logger } from '../../utils/logger';
import { Session } from '../session/session.service';

/**
 * @description Error.
 * @exports
 * @returns {ErrorLink}
 */
export function error(): ErrorLink {
  const session = inject(Session);

  const logger = Logger.getInstance('GraphQLModule').child(`ErrorLink`);

  return new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      // Handle GraphQL errors
    } else if (CombinedProtocolErrors.is(error)) {
      // Handle multipart subscription protocol errors
    } else if (LocalStateError.is(error)) {
      // Handle errors thrown by the `LocalState` class
    } else if (ServerError.is(error)) {
      // Handle server HTTP errors
    } else if (ServerParseError.is(error)) {
      // Handle JSON parse errors
    } else if (UnconventionalError.is(error)) {
      // Handle errors thrown by irregular types
    } else {
      // Handle other errors
    }

    // Log the error to the console
    logger.error(error);

    // Log the error to Sentry
    Sentry.withScope((scope) => {
      scope.setTag('kind', 'graphql');
      scope.setTag('session', session.profile?.id);
      scope.setExtra('error', error);
      scope.setExtra('operation', {
        name: operation.operationName,
        type: operation.operationType,
        query: operation.query.loc?.source.body,
        variables: operation.variables
      });
      scope.setTransactionName(operation.operationName ?? `GraphQL Error`);
      Sentry.captureException(error, scope);
    });
  });
}
